<template>
  <div class="appletBottomnav" style="background:#fff;" :style="{'padding-bottom': isShowPadding() ? '34px' : '0'}">
    <van-tabbar @change="changeTabBar" :fixed="false" class="van-hairline--top" :border="false" v-model="active" style="z-index: 10;">
      <van-tabbar-item replace name="Nearby" :to="isLogin && '/Applet/Chargingpile/Nearby/Page'">附近</van-tabbar-item>
      <van-tabbar-item replace name="Charge" to="/Applet/Chargingpile/Main/Page">充电</van-tabbar-item>
      <van-tabbar-item replace name="Order" :to="isLogin && '/Applet/Chargingpile/OrderList/Page'">订单</van-tabbar-item>
      <van-tabbar-item replace name="Mine"   to="/Applet/Chargingpile/Mine/Page"> 我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  export default {
    name: 'MenuEngine', /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        active: "",
        sensorInfoCount: null,
        isLogin: false,
      }
    },
    created: function () {
      this.init();
    },
    updated: function () {
      if (this.octopus.passport['token']) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
      this.octopus.tips.debug("[AppMenuEngine执行了updated事件。");
    },
    // 活动事件，写在这里的好处是不管是第一次创建还是后退回来，都会触发这个事件
    // 比较典型的就是列表组件，返回的时候往往是需要刷新的。
    activated: function () {
      if (this.octopus.tools.parseQuery('model')) {
        this.octopus.applet.model = this.octopus.tools.parseQuery('model');
      }
      this.load();
    },
    // 组件停用时，也就是切换出去的时候，需要注意的是，AppMenuEngine组件切换出去，不允许缓存，需要释放到初始状态，以便于下次进来。
    deactivated: function () {
      this.destroyData();
      this.octopus.tips.debug("AppMenuEngine执行了deactivated事件。");
    },
    computed: {
      // 如果cellData数据发生了改变,则触发这个事件。
      changeCell: function () {
        return this.source.id;
      },
      changePage: function () {

      }
    },
    methods: {
      isShowPadding() {
        return this.octopus.applet.isShowAppletPadding();
      },
      async changeTabBar() {
        if (this.active == 'Nearby' || this.active == 'Order') {
          if (!this.isLogin) {  
            this.load();
            let isLogin = await this.octopus.applet.noLoginToPage(this);
            if (!isLogin) return;

          }
        } 
      },
      init: function () {
        this.initData();
      },
      // 初始化数据，主要是还原#param等预设参数，重新绑定。
      initData: function () {

      },
      // 执行加载
      load: function () {
        let o = this;
        let modelurl = this.octopus.router.get().fullPath.toLocaleLowerCase();
        if (modelurl.indexOf("nearby") > -1) {
          this.active = "Nearby";
        } else if (modelurl.indexOf("main") > -1) {
          this.active = "Charge";
        } else if (modelurl.indexOf("order") > -1) {
          this.active = "Order";
        } else if (modelurl.indexOf("mine") > -1) {
          this.active = "Mine";
        }
      },
      // 组件停用时把data修正回原始数据，其他属性因为不会变，所以不用还原。
      destroyData: function () {

      },
      // 控件数据变更事件
      change: function (new_cell, old_cell) {

      },
    },
    watch: {},
    props: ["changed"]
  }

</script>



// WEBPACK FOOTER //
// src/components/Engine/FrameworkAPPLET/MenuEngine.vue